export const SET_USER_OPTIONS = "SET_USER_OPTIONS";

const _setUserOptions = /* istanbul ignore next - Action Creator */ (
    status,
    data,
    err
) => {
    return { type: SET_USER_OPTIONS, data, err, status };
};

const setUserOptions = /* istanbul ignore next - Pure passthrough */ optionsHash => {
    return (dispatch, getState, Request) => {
        return Promise.resolve(
            dispatch(_setUserOptions("success", optionsHash, null))
        );
    };
};

const toggleSlideShow = /* istanbul ignore next - Pure passthrough */ () => {
    return (dispatch, getState, Request) => {
        return Promise.resolve(
            dispatch(
                _setUserOptions(
                    "success",
                    {
                        slideShow: !getState().config.slideShow
                    },
                    null
                )
            )
        );
    };
};

class CreatorConfigAction {
    static setUserOptions = setUserOptions;
    static toggleSlideShow = toggleSlideShow;
}

export default CreatorConfigAction;
